import styled from 'styled-components';

export const UploadBox = styled.div`
  min-width: 120px;
  position: relative;
`;

export const ErrorBox = styled.div`
  position: absolute;
  left: 0;
  top: 50px;
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  width: 265px;
  text-transform: uppercase;
`;
